import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { useSwaggerlessContext } from 'Context/SwaggerlessContext';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './index.css';
import { withHousehold } from 'Context/HouseholdContext';
import NoteSection from './NoteSection';

const NoteContainer = ({ sectionId }) => {
  const { householdResource } = useSimpleHousehold();
  const { getQuestionnaireSectionNotesBySection } = useSwaggerlessContext();
  const [sectionNotes, setSectionNotes] = useState(null);

  useEffect(() => {
    const getNotes = async () => {
      const res = await getQuestionnaireSectionNotesBySection(householdResource.id(), sectionId);
      setSectionNotes(res);
    };
    getNotes();
  }, [householdResource]);

  if (!sectionNotes) {
    return null;
  }

  return (
    <div className="section-note-container">
      <NoteSection
        type="recommendation"
        sectionId={sectionId}
        sectionNotes={sectionNotes.filter(
          n => n.attributes.type === 'recommendation',
        )}
      />
      <NoteSection
        type="strategy"
        sectionId={sectionId}
        sectionNotes={sectionNotes.filter(n => n.attributes.type === 'strategy')}
      />
      <NoteSection
        type="footnote"
        sectionId={sectionId}
        sectionNotes={sectionNotes.filter(n => n.attributes.type === 'footnote')}
      />
    </div>
  );
};

NoteContainer.propTypes = {
  sectionId: PropTypes.string.isRequired,
};

NoteContainer.defaultProps = {
};

export default withHousehold(NoteContainer);
